import _ from "lodash";
import React, { useEffect, useState } from "react";
import RepeatEventModal from "../RepeatEventModal";
import {
  END_TYPES,
  RepeatEventProvider,
  useRepeatEvent,
} from "../../context/RepeatEventContext";
import EventRow from "../EventRow/EventRow";
import { ReloadArrowOutlined } from "@toddle-edu/ds-icons";
import { Checkbox, DSProvider, SelectDropdown } from "@toddle-edu/ds-web";
import {
  setValue,
  mapStateToProps,
  mapActionCreators,
  DEFAULT_OCCURRENCES,
} from "../../modules/Utils";
import { connect } from "react-redux";
import { useI18n } from "Hooks";
import {
  getRepeatEventOptions,
  getSubText,
  getErrorText,
  getSummaryText,
} from "MyCalendar/modules/Selector";
import classNames from "classnames";
import classes from "./RepeatEvent.scss";
import { getDateMomentObject } from "Utils/DateTimeHelpers";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import { getSelectedSchoolDetailsForCalendar } from "MyCalendar/modules/Utils";
import { useOperationalDays } from "../../hooks";
import {
  getSelectedAcademicYearIdForSchool,
  getSelectedAcademicYearForSchool,
} from "../../../../modules/Utils";

//2DTODO: Remove holiday and whole school event from dropdown for staff for creation and editing
const RepeatEventOptionsDropdownList = ({
  setSelectedEventType,
  eventType,
  errors,
  repeatEventOptionList,
  testId,
  showBorder,
  dropdownContainerClass = "",
  skipNonOperationalDays,
  setSkipNonOperationalDays,
  skipNonOperationalDaysClassName = "",
  isEverySchoolDaySelected,
  subText,
  repeatEventSettings,
  horizontalMarginClass = "",
  isFullScreenMode,
}) => {
  const { t } = useI18n(["calendar"]);

  const skipNonOperationalDaysHandler = () => {
    setSkipNonOperationalDays(!skipNonOperationalDays);
  };
  const { actions } = useRepeatEvent();
  const showSkipNonOperationalDayCheckbox = _.isEmpty(
    repeatEventSettings?.weekDays
  );
  useEffect(() => {
    actions.setInitialState({
      ...repeatEventSettings,
      occurrences: repeatEventSettings?.count || DEFAULT_OCCURRENCES,
      repeatType: repeatEventSettings?.frequency,
    });
  }, [repeatEventSettings]);

  return (
    <div
      className={classNames(classes.eventTypeDropdown, dropdownContainerClass)}
    >
      <SelectDropdown
        name={"tag"}
        placeholder={t("calendar:select_the_event_type")}
        options={repeatEventOptionList}
        value={eventType}
        onChange={setSelectedEventType}
        isMulti={false}
        isClearable={false}
        size={"medium"}
        error={errors.tag}
        testId={`${testId}-eventTag`}
        variant={showBorder ? "outlined" : "plain"}
        classNamePrefix={"repeat-event-type-dropdown"}
      />
      {showSkipNonOperationalDayCheckbox ? (
        <div
          className={classNames(
            classes.skipNonOperationalDays,
            skipNonOperationalDaysClassName
          )}
        >
          <Checkbox
            isChecked={skipNonOperationalDays}
            onChange={skipNonOperationalDaysHandler}
            className={classes.repeatEventCheckbox}
            dsVersion={"2.0"}
            disabled={isEverySchoolDaySelected}
            testId={`skip_non_operational_days-repeatEvent-checkbox`}
          >
            <div className={classNames("text-body", classes.label)}>
              {t("calendar:skip_non_operational_days")}
            </div>
          </Checkbox>
        </div>
      ) : null}
      {showSkipNonOperationalDayCheckbox ? (
        <div
          className={classNames(
            classes.horizontalSeperator,
            horizontalMarginClass
          )}
        />
      ) : (
        <div
          className={classNames({
            [classes.marginTop]: !isFullScreenMode,
            [classes.fullScreenMarginTop]: isFullScreenMode,
          })}
        />
      )}
      <div
        className={classNames(
          "text-body-s",
          classes.recurrenceText,
          horizontalMarginClass
        )}
      >
        {subText}
      </div>
    </div>
  );
};

const getRepeatEventType = (repeatEventOptionList, id) => {
  return _.find(repeatEventOptionList, { id: id });
};

const isEverySchoolDaySelected = repeatEventSettings =>
  repeatEventSettings?.id === "school_day";

const RepeatEvent = props => {
  const {
    eventModalV2,
    updateEventModalV2,
    dropdownContainerClass,
    showBorder = false,
    skipNonOperationalDaysClassName,
    academicEndDate,
    curriculumProgramId,
    currentAcademicYearId,
    horizontalMarginClass = "",
    repeatTitleLocaleKey = "calendar:repeat_event",
    isFullScreenMode,
  } = props;
  const setRepeatEventSettings = setValue(
    "repeatEventSettings",
    updateEventModalV2
  );
  const setSkipNonOperationalDays = setValue(
    "skipNonOperationalDays",
    updateEventModalV2
  );
  const { t } = useI18n();

  const { operationalDaysData } = useOperationalDays();
  const operationalDays = _.get(
    operationalDaysData,
    "node.globalConstants[0].value",
    []
  );

  // State for RepeatEventModal
  const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);

  const [repeatEventOptionList, setRepeatEventOptionList] = useState(
    () =>
      getRepeatEventOptions({
        date: eventModalV2?.startDate,
        t,
        curriculumProgramId,
        currentAcademicYearId,
      }) || []
  );
  const { skipNonOperationalDays, repeatEventSettings = {} } = eventModalV2;

  useEffect(() => {
    setRepeatEventOptionList(
      getRepeatEventOptions({
        date: eventModalV2?.startDate,
        t,
        curriculumProgramId,
        currentAcademicYearId,
        repeatEventSettings,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // if (_.isEmpty(repeatEventSettings)) {
    //   setRepeatEventSettings(repeatEventOptionList[1]?.value);
    // }
  }, []);

  const { readOnlyExistingRepeatEventSettings = null } = eventModalV2 || {};

  useEffect(() => {
    setRepeatEventOptionList(
      getRepeatEventOptions({
        date: eventModalV2?.startDate,
        t,
        curriculumProgramId,
        currentAcademicYearId,
        repeatEventSettings,
      })
    );
  }, [eventModalV2?.startDate, curriculumProgramId, currentAcademicYearId]);

  useEffect(() => {
    // don't change repeat event settings on edit mode
    if (!_.isEmpty(readOnlyExistingRepeatEventSettings)) return;
    const rrValue = getRepeatEventType(
      repeatEventOptionList,
      repeatEventSettings?.id
    )?.value;
    setRepeatEventSettings({ ...repeatEventSettings, ...rrValue });
  }, [
    repeatEventOptionList,
    repeatEventSettings?.id,
    readOnlyExistingRepeatEventSettings,
  ]);

  if (_.isEmpty(repeatEventOptionList)) {
    return (
      <EventRow
        label={"calendar:repeat"}
        isRequired={true}
        icon={<ReloadArrowOutlined variant="subtle" />}
        renderComponent={() => (
          <div className={classes.noEventTypeMessage}>
            {t("calendar:no_event_type_available")}
          </div>
        )}
      />
    );
  }

  const repeatEventHandler = selectedOption => {
    // Check if custom option is selected
    if (selectedOption?.value?.id === "custom") {
      setIsCustomModalOpen(true);
      return;
    }

    setRepeatEventSettings(selectedOption?.value);

    // when predefined option select update repeat event options list initial state
    setRepeatEventOptionList(
      getRepeatEventOptions({
        date: eventModalV2?.startDate,
        t,
        curriculumProgramId,
        currentAcademicYearId,
      })
    );
    if (isEverySchoolDaySelected(selectedOption?.value)) {
      setSkipNonOperationalDays(true);
    } else {
      setSkipNonOperationalDays(false);
    }
  };

  const handleCustomModalClose = () => {
    setIsCustomModalOpen(false);
  };

  const getCustomOptionValue = customSettings => {
    const {
      interval,
      repeatType,
      endType,
      endDate,
      occurrences,
      weekDays,
      monthDays,
      setPositions,
      timezone,
    } = customSettings;
    const finalEndDate = endDate
      ? getDateMomentObject(endDate).format(DATE_TIME_CONSTANTS.YYYY_MM_DD)
      : null;
    const customOptionValue = {
      id: "custom",
      frequency: repeatType,
      weekDays,
      interval,
      monthDays,
      setPositions,
      endType,
      repeatType,
      timezone,
    };
    if (endType === END_TYPES.AFTER_OCCURRENCES) {
      customOptionValue.count = occurrences;
    } else {
      customOptionValue.endDate = finalEndDate;
    }
    return customOptionValue;
  };

  const handleCustomModalDone = (customSettings = {}) => {
    const customOptionValue = getCustomOptionValue(customSettings);

    const { customLabelText } = getSummaryText({
      t,
      state: { ...customOptionValue, academicYearEndDate: academicEndDate },
      date: eventModalV2?.startDate,
    });
    setRepeatEventOptionList(prevOptions => {
      const newList = [...prevOptions];
      // Insert customOptionValue at second last position
      if (newList[newList.length - 2]?.id === "custom") {
        newList[newList.length - 2] = {
          value: customOptionValue,
          label: customLabelText,
          id: "custom",
        };
      } else {
        newList.splice(newList.length - 1, 0, {
          value: customOptionValue,
          label: customLabelText,
          id: "custom",
        });
      }

      return newList;
    });
    setRepeatEventSettings(customOptionValue);
    setIsCustomModalOpen(false);
  };

  const subText = getSubText({
    t,
    repeatEventSettings,
    date: eventModalV2?.startDate,
  });
  const { errorText } = getErrorText({
    t,
    state: repeatEventSettings,
    operationalDays,
    skipNonOperationalDays,
  });

  const errors = {};
  return (
    <RepeatEventProvider academicYearEndDate={academicEndDate}>
      <DSProvider dsVersion="2.0">
        <EventRow
          label={"calendar:repeat"}
          isRequired={true}
          labelClass={classes.rowLabel}
          className={classes.rowContainer}
          icon={<ReloadArrowOutlined variant="subtle" />}
          renderComponent={() => (
            <RepeatEventOptionsDropdownList
              setSelectedEventType={repeatEventHandler}
              eventType={getRepeatEventType(
                repeatEventOptionList,
                repeatEventSettings?.id
              )}
              errors={errors}
              repeatEventOptionList={repeatEventOptionList}
              testId="event-type-dropdown"
              dropdownContainerClass={dropdownContainerClass}
              showBorder={showBorder}
              skipNonOperationalDays={skipNonOperationalDays}
              setSkipNonOperationalDays={setSkipNonOperationalDays}
              skipNonOperationalDaysClassName={skipNonOperationalDaysClassName}
              isEverySchoolDaySelected={isEverySchoolDaySelected(
                repeatEventSettings
              )}
              subText={subText}
              errorText={errorText}
              setRepeatEventSettings={setRepeatEventSettings}
              repeatEventSettings={repeatEventSettings}
              operationalDays={operationalDays}
              horizontalMarginClass={horizontalMarginClass}
              isFullScreenMode={isFullScreenMode}
            />
          )}
        />

        <RepeatEventModal
          isOpen={isCustomModalOpen}
          onClose={handleCustomModalClose}
          onDone={handleCustomModalDone}
          eventStartDate={eventModalV2?.startDate}
          academicYearEndDate={academicEndDate}
          skipNonOperationalDays={skipNonOperationalDays}
          setSkipNonOperationalDays={setSkipNonOperationalDays}
          operationalDays={operationalDays}
          repeatTitleLocaleKey={repeatTitleLocaleKey}
        />
      </DSProvider>
    </RepeatEventProvider>
  );
};

const localMapStateToProps = state => {
  const academicYearSelected = getSelectedAcademicYearForSchool(state);
  const {
    startDate: academicStartDate,
    endDate: academicEndDate,
  } = academicYearSelected;
  const {
    currentCurriculumProgramId: curriculumProgramId,
  } = getSelectedSchoolDetailsForCalendar(state);
  const currentAcademicYearId = getSelectedAcademicYearIdForSchool(state);
  return {
    ...mapStateToProps(state),
    curriculumProgramId,
    currentAcademicYearId,
    academicStartDate,
    academicEndDate,
  };
};

export default connect(localMapStateToProps, mapActionCreators)(RepeatEvent);
